export default "__VITE_ASSET__CbC5eOyq__"